import { z } from 'zod';
import apiClient from '../client';

const getLatestAccountSchema = z.object({
  trackId: z.string()
});

// Clean profile schema - only profile table fields
const updateProfileSchema = z.object({
  email: z.string().email(),
  fullName: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  country: z.string().optional(),
  apartment: z.string().optional(),
  town: z.string().optional(),
  state: z.string().optional(),
  companyName: z.string().optional(),
  postalCode: z.string().optional(),
  streetAddress: z.string().optional(),
  dateOfBirth: z.string().optional(),
  phone: z.string().optional(),
  bio: z.string().optional(),
  name: z.string().optional(),
});

export const profile = {
  getLatestAccount: async (trackId: string) => {
    const validated = getLatestAccountSchema.parse({ trackId });
    const response = await apiClient.post('/profile/get-latest-account', validated);
    return response.data;
  },

  updateProfile: async (data: z.infer<typeof updateProfileSchema> | FormData) => {
    // If it's FormData (file upload), send directly without validation
    if (data instanceof FormData) {
      const response = await apiClient.post('/profile/update', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    }
    
    // Otherwise, validate as usual for JSON data
    const validated = updateProfileSchema.parse(data);
    const response = await apiClient.post('/profile/update', validated);
    return response.data;
  },

  getProfile: async (email: string) => {
    const response = await apiClient.post('/profile/get', { email });
    return response.data;
  },

  uploadImage: async (formData: FormData) => {
    const response = await apiClient.post('/profile/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  uploadProfilePicture: async (file: File) => {
    const formData = new FormData();
    formData.append('picture', file);
    
    const response = await apiClient.post('/profile/upload-profile-picture', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  getUserAccounts: async (email: string) => {
    const response = await apiClient.post('/profile/get-accounts', { email });
    return response.data;
  },

  changePassword: async (newPassword: string) => {
    const response = await apiClient.post('/profile/change-password', { newPassword });
    return response.data;
  },
};